import './piano-ferie.scss';

import React, { useState, useRef, useContext, useEffect } from 'react';
import { ThemeContext } from '../../themes/theme';
import { useScreenSize, useScreenSizeClass } from '../../utils/media-query';
import { DataGrid, DateBox, NumberBox, LoadPanel } from 'devextreme-react';
import { Column, Toolbar, DataGridRef, Scrolling, SearchPanel, Item } from "devextreme-react/data-grid";
import useApiConfiguration from '../../apiConfig';
import { PianoAssenzeApi } from '../../data';

export default function PianoFerie() {
    const gridRef = useRef<DataGridRef>(null);
    const apiConfiguration = useApiConfiguration();

    const themeContext = useContext(ThemeContext);
    const isDarkMode = themeContext?.theme === "dark";
    const { isLarge, isMedium } = useScreenSize();
    const screenSizeClass = useScreenSizeClass();

    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState(() => {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), 1);
    });
    const [numeroMesi, setNumeroMesi] = useState<number>(1);
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [giorniDataSource, setGiorniDataSource] = useState<string[]>([]);

    function refreshData() {
        const api = new PianoAssenzeApi(apiConfiguration);
        const dataFiltro = new Date(data.getFullYear(), data.getMonth(), 1);

        api.getPianoAssenzeV2({
            data: dataFiltro,
            numeroMese: numeroMesi
        }).then((response) => {
            setDataSource(response);

            if (response?.length > 0 && response[0].giorni) {
                const days = response[0].giorni.map((g: any) => g.data);
                setGiorniDataSource(days);
            }
        }).catch((error) => {
            console.error(error);
        }).finally(() => setLoading(false))
    };

    useEffect(() => {
        setLoading(true);
        refreshData();
    }, [data, numeroMesi]);

    return (
        <React.Fragment>
            {
                loading && <LoadPanel style={{ zIndex: 9999 }} shading={true} shadingColor='rgba(0, 0, 0, 0.4)' position={'center'} visible={true} />
            }

            <div className='view-list-piano-ferie'>
                <div className={`view-wrapper view-wrapper-list list-page ${screenSizeClass}`}>
                    <DataGrid
                        id="gridPianoFerie" ref={gridRef} key="idPersonale"
                        dataSource={dataSource} allowColumnResizing columnResizingMode='widget'
                        showBorders rowAlternationEnabled wordWrapEnabled className='grid theme-dependent'
                    >
                        <Scrolling mode='virtual' columnRenderingMode='standard' showScrollbar='always' />
                        <SearchPanel visible placeholder='Ricerca' />

                        <Toolbar>
                            <Item location='before'>
                                <div className='grid-header'>Piano Ferie</div>
                            </Item>
                            
                            <Item location='center' locateInMenu='never' showText='inMenu' widget='dxDateBox'>
                                <DateBox 
                                    className={`dataSearch ${screenSizeClass}`}
                                    label="Mese" labelMode='floating'
                                    showClearButton={false}
                                    type="date" value={data}
                                    onValueChanged={(e) => setData(e.value)}
                                    displayFormat={ (isLarge || isMedium) ? "MMMM yyyy" : "MM/yyyy" }
                                    inputAttr={{ readonly: true }}
                                    openOnFieldClick
                                    calendarOptions={{
                                        maxZoomLevel: 'year',
                                        minZoomLevel: 'century'
                                    }}
                                />
                            </Item>

                            <Item location='center' locateInMenu='auto' showText='inMenu'>
                                <NumberBox 
                                    className={`numeroSearch ${screenSizeClass}`}
                                    value={numeroMesi} min={1} max={12} defaultValue={1}
                                    label='Numero mesi' labelMode='floating'
                                    onValueChanged={(e) => setNumeroMesi(e.value != null ? e.value : 1)}
                                />
                            </Item>

                            <Item locateInMenu='auto' location='after' showText='inMenu' name='searchPanel' />
                        </Toolbar>

                        <Column dataField='nominativo' fixed width={200} />

                        {
                            giorniDataSource.map((day, index) => (
                                <Column key={index} caption={day} alignment='center' width={110}
                                    cellRender={({ data }) => {
                                        const cell = data.giorni[index];
                                        if (!cell) return null;

                                        var colore = cell.colore != "red" && isDarkMode ? "white" : cell.colore;

                                        return (
                                            <div style={{ color: colore, minHeight: "22px", padding: "2px 0" }}>
                                                {cell.testo}
                                            </div>
                                        )
                                    }}
                                />
                            ))
                        }
                    </DataGrid>
                </div>
            </div>
        </React.Fragment>
    );
}